const KEY_PREFIX = 'm24AiNudgeDismissed:';

/** The localStorage key of one user. The card stays hidden for that user in that browser. */
export const aiNudgeDismissedKey = (userId: number): string => `${KEY_PREFIX}${userId}`;

/** A browser that blocks localStorage counts as "not dismissed": the card can show. */
export function readAiNudgeDismissed(userId: number): boolean {
  try {
    return window.localStorage.getItem(aiNudgeDismissedKey(userId)) !== null;
  } catch {
    return false;
  }
}

export function writeAiNudgeDismissed(userId: number): void {
  try {
    window.localStorage.setItem(aiNudgeDismissedKey(userId), '1');
  } catch {
    // The card hides for this page view only.
  }
}
